import { AfterViewInit, Component, ElementRef, Renderer2 } from '@angular/core';
import { DetailTableColumn } from 'src/app/components/modal-carbon-credit-detail/modal-carbon-credit-detail.component';
import { formatCPFOrCNPJ } from 'src/app/helpers/utils/cpf-cnpj.util';
import { CarbonOperation } from 'src/app/shared/interfaces/carbon-operation';
import { AppModalOverlayRef } from 'src/app/shared/services/app-modal.service';

@Component({
  standalone: false,
  selector: 'app-modal-withdrawal-transfer-detail',
  templateUrl: './modal-withdrawal-transfer-detail.component.html',
  styleUrls: ['./modal-withdrawal-transfer-detail.component.scss'],
})
export class ModalWithdrawalTransferDetailComponent implements AfterViewInit {
  readonly title = 'Detalhes do Crédito de Carbono';
  readonly columns: DetailTableColumn[] = [
    { label: 'Cod. IF', flex: 179 },
    { label: 'Quant.', flex: 124 },
    { label: 'Emissor', flex: 182 },
    { label: 'Detentor', flex: 182 },
    { label: 'Comitente', flex: 182 },
  ];

  carbonCreditCode = '';
  creditQuantity: string | number = '';
  emissor = '';
  detentor = '';
  comitenteDocumentNumber = '';

  constructor(
    public dialogRef: AppModalOverlayRef<ModalWithdrawalTransferDetailComponent>,
    private el: ElementRef,
    private renderer: Renderer2,
  ) {
    const operation: CarbonOperation = this.dialogRef?.data?.operation ?? ({} as CarbonOperation);
    this.carbonCreditCode = operation.carbonCreditCode ?? '';
    this.creditQuantity = operation.creditQuantity ?? '';
    this.emissor = operation.purchaserCode ?? '';
    this.detentor = operation.holderCode ?? '';
    const rawComitente = this.dialogRef?.data?.comitenteDocumentNumber ?? '';
    this.comitenteDocumentNumber = rawComitente ? formatCPFOrCNPJ(rawComitente) : '';
  }

  close(): void {
    this.dialogRef.close();
  }

  ngAfterViewInit(): void {
    this.renderer.setStyle(this.el.nativeElement, 'display', 'contents');
  }
}
